module.exports = __webpack_public_path__ + "images/thumbprint.274d67b7a9c52fffc206534972b02e7a.png";